<template>
  <div class="h-screen bg-slate-100 flex flex-col">
    <div class="flex-1">
      <slot />
    </div>
    <!-- ICP备案信息 -->
    <footer class="text-center py-2 text-xs text-gray-400 bg-slate-100">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="hover:text-gray-600 transition-colors">
        滇ICP备2025074003号
      </a>
    </footer>
  </div>
</template>

<script setup lang="ts">
</script>
